function c(t,n){return t.concat(n).reduce((e,r)=>e.find(u=>u.key===r.key)?e:[...e,r],[])}export{c as mergeCustomAttributes};
//# sourceMappingURL=merge-custom-attributes.js.map
